import { descriptorOf } from '@tencent/workbench-core';
import { $logger } from '../../../controllers/logger/logger.js';
import { isDynamicLoader, checkLoadState, loadDynamicLoader } from '../../../utils/loader-util.js';

function isLoadingOption(x) {
    if (!x || typeof x === 'string') {
        return false;
    }
    return ['string', 'undefined'].includes(typeof x.loaderKey)
        || ['function', 'undefined'].includes(typeof x.onLoading)
        || ['function', 'undefined'].includes(typeof x.onLoadFinish);
}
/**
 * 方法装饰器，loader执行完毕后，自动执行该方法
 * @param loaderKey - loader变量名
 * @public
 */
function awaitLoad(param) {
    var _a;
    let loaderKey = 'loader';
    if (typeof param === 'string') {
        loaderKey = param;
    }
    let loadingOption = undefined;
    if (isLoadingOption(param)) {
        loadingOption = param;
        loaderKey = (_a = param.loaderKey) !== null && _a !== void 0 ? _a : 'loader';
    }
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    return function (target, targetKey, descriptor) {
        if (descriptor === undefined) {
            descriptor = descriptorOf(target, targetKey);
        }
        const originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            var _a;
            const loader = this[loaderKey];
            if (!isDynamicLoader(loader)) {
                $logger.warn(`${String(loaderKey)} is not DynamicLoader`);
                return originalMethod.call(this, ...args);
            }
            if (checkLoadState(loader)) {
                return originalMethod.call(this, ...args);
            }
            (_a = loadingOption === null || loadingOption === void 0 ? void 0 : loadingOption.onLoading) === null || _a === void 0 ? void 0 : _a.call(loadingOption);
            const element = loadDynamicLoader(loader).then(() => {
                var _a;
                const result = originalMethod.call(this, ...args);
                (_a = loadingOption === null || loadingOption === void 0 ? void 0 : loadingOption.onLoadFinish) === null || _a === void 0 ? void 0 : _a.call(loadingOption);
                return result;
            });
            return element;
        };
    };
}

export { awaitLoad };
//# sourceMappingURL=await-load.js.map
